<template>
  <div class="d-flex download-pop">
    <div class="flex-1 bg-white text-center p-3">
      <div class="font-size-22 fw-bold mt-1">Vận hành doanh nghiệp ngay trên thiết bị di động của bạn</div>
      <div class="font-size-16 text-info fw-bold mt-2">Tải ứng dụng Salework</div>
      <img src="/assets/images/downloadApp/image_qr.svg" class="mt-2 download-pop-qr">
      <div class="font-size-16 fw-bold mt-3 text-gray">Quét mã QR</div>
      <div class="d-flex justify-content-between mt-3">
        <img src="/assets/images/downloadApp/image_google.svg" class="mx-1 pointer"
             @click="newTab('https://play.google.com/store/apps/details?id=vn.esbt.saleworkmobile')">
        <img src="/assets/images/downloadApp/image_apple.svg" class="mx-1 pointer"
             @click="newTab('https://apps.apple.com/vn/app/salework/id1563351759')">
      </div>
    </div>
    <div class="flex-1 download-col-right justify-content-center d-flex">
      <img src="/assets/images/downloadApp/image_app.svg" class="mt-4">
    </div>
  </div>
</template>

<script>
export default {
  name: "DownLoadApp",
  methods: {
    newTab(path) {
      window.open(path, "_blank");
    }
  }
}
</script>
<style scoped>
.download-pop {
  min-height: 400px;
  max-height: 450px;
  word-break: break-word;
}

.download-col-right {
  background-color: #EAECF2;
}

.download-pop-qr {
  width: 182px;
  height: 182px;
}
</style>